webpackJsonp([32239989425883],{

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(37);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(47);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(46);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(110);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(109);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$Component) {
	  _inherits(Hero, _React$Component);
	
	  function Hero() {
	    _classCallCheck(this, Hero);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Hero.prototype.render = function render() {
	    var _props$data$markdownR = this.props.data.markdownRemark.frontmatter,
	        heading = _props$data$markdownR.hero_heading,
	        subheading = _props$data$markdownR.hero_subheading;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: "hero" },
	      _react2.default.createElement(
	        "div",
	        { className: "hero__left" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          heading
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          subheading
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "hero__right" },
	        this.props.children
	      )
	    );
	  };
	
	  return Hero;
	}(_react2.default.Component);
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = AboutPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(36);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _PageHeader = __webpack_require__(12);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	__webpack_require__(412);
	
	__webpack_require__(89);
	
	var _aboutContent = __webpack_require__(209);
	
	var _gatsbyImage = __webpack_require__(297);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _links = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Officer from '../components/Officer';
	var faqContent = [{
	  question: "What is Innovative Design?",
	  answer: "Innovative Design (“InnoD”) is a creative agency and ASUC Charter Program that is run entirely by students. Our members are talented graphic designers, photographers, and web designers. Together, we strive to Make Berkeley Beautiful by providing design education and services to the campus community."
	}, {
	  question: "How much do your services cost?",
	  answer: "Innovative Design’s services are pro-bono (at no cost) for clients affiliated with UC Berkeley, like student clubs or academic departments. For off-campus clients, please contact us for more information."
	}, {
	  question: "How do I join Innovative Design?",
	  answer: "We recruit new members at the beginning of every semester! Information is posted on our website and Facebook page at the beginning of every semester."
	}, {
	  question: "How do I get in touch with you?",
	  answer: "Feel free to message us on Facebook or email us at innovativedesignatcal@gmail.com!"
	}, {
	  question: "What design education do you offer?",
	  answer: "For Berkeley students, we offer three DeCals: Intro to Photoshop and Illustrator, Photography Principles, and Graphic Design Principles. All three are offered every semester, and information is posted on our website and Facebook page at the beginning of every semester.For the general public, we offer events twice a semester. These include HEX (member-led creative workshop), CMYK (a design competition with a real client), and RGB (an industry speaker panel). Information is posted on our website and Facebook page at the beginning of every semester."
	}, {
	  question: "What do members of the club do?",
	  answer: "As a member of Innovative Design, you will be a part of a team of other designers and photographers that work together on client work and personal projects. You will have 2 hours of meeting a week that consist of workshops, tutorials, critiques with your team members and team leads. You will also be a part of our larger design family and join our member-led workshop series HEX, our design events RGB and CMYK, and club socials to get to know members in other disciplines. Members are also welcome to audit our DeCals."
	}, {
	  question: "Are you related to the club with the same name at USC?",
	  answer: "Yes. InnoD at USC is our sister club based at the University of Southern California."
	}, {
	  question: "Who leads the club?",
	  answer: "InnoD is led by an officer board consisting of experienced members. Current members are able to apply to become an officer at the end of every semester."
	}, {
	  question: "Do I need to re-apply every semester?",
	  answer: "Yes. Our members must re-apply for every semester they would like to be an active member. However, our member benefits are available to any past or current member at any time."
	}];
	// import { off } from 'superagent';
	
	
	function FAQ(props) {
	  function FAQuestion(props) {
	    var faq = props.faq;
	
	    var _useState = (0, _react.useState)(false),
	        isOpen = _useState[0],
	        setIsOpen = _useState[1];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        { className: 'g__ex__link faq__question', href: 'javascript:;', onClick: function onClick() {
	            return setIsOpen(!isOpen);
	          } },
	        faq.question
	      ),
	      isOpen ? _react2.default.createElement(
	        'p',
	        { className: 'fade__in' },
	        faq.answer
	      ) : _react2.default.createElement('p', null)
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__flex__col' },
	    props.content.map(function (faq) {
	      return _react2.default.createElement(FAQuestion, { faq: faq });
	    })
	  );
	}
	
	var valuesContent = [{
	  title: "Accessibility",
	  img: "/img/about/ACCESSIBILITY.png",
	  description: "We promote and value the personal and creative growth of our members. We are always learning and helping others."
	}, {
	  title: "Diversity",
	  img: "/img/about/DIVERSITY.png",
	  description: "We value exploration and curiosity for learning. We are eager to learn from our community."
	}, {
	  title: "Community",
	  img: "/img/about/COMMUNITY.png",
	  description: "We welcome new ideas and diverse thinking. We strive to question the status quo and think outside of the box."
	}];
	
	function Values(props) {
	  function ValueItem(props) {
	    var value = props.value;
	    return _react2.default.createElement(
	      'div',
	      { className: 'g__flex__col value__widget' },
	      _react2.default.createElement('img', { className: 'value__img', src: value.img }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        value.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        value.description
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__flex__row values' },
	    props.content.map(function (value) {
	      return _react2.default.createElement(ValueItem, { value: value });
	    })
	  );
	}
	
	var teamsContent = [{
	  title: "Design",
	  description: "Our Gold Design Team designers work with on campus organizations for a variety of graphic design related servies. From flyers, banners, logos, and more we provide pro-bono services to support our student and local communities. In addition, teams focus on portfolio development for members through personal projects and workshops for skill building.",
	  img: "/img/about/DESIGN-GOLD.png",
	  extra: "Gold",
	  extraColor: "#D4AF37",
	  applyLink: _links.applyClub_DESIGN_GOLD,
	  requestLink: ""
	}, {
	  title: "Design",
	  description: "Our Blue Design Team designers work with off campus clients for industry level design work. This team provides branding packages and other design services to professional clients.",
	  img: "/img/about/DESIGN-BLUE.jpg",
	  extra: "Blue",
	  extraColor: "#0038C9",
	  applyLink: _links.applyClub_DESIGN_BLUE,
	  requestLink: ""
	}, {
	  title: "Photo",
	  description: "Our photo teams cover events and photoshoots for on-campus organizations. They meet during the week, as a team, to shoot for your personal portfolio, receive instruction, and build a community with photographers.",
	  img: "/img/about/PHOTO.jpg",
	  extra: "",
	  extraColor: "",
	  applyLink: _links.applyClub_PHOTO,
	  requestLink: ""
	}, {
	  title: "Web",
	  description: "Hone your design and development skills as you create layout mockups and build websites for clients.",
	  img: "/img/about/WEB.jpg",
	  extra: "",
	  extraColor: "",
	  applyLink: _links.applyClub_WEB,
	  requestLink: ""
	}];
	
	// TODO
	function Teams(props) {
	  function Team(props) {
	    var team = props.team;
	    return _react2.default.createElement(
	      'div',
	      { className: 'g__flex__row team__widget' },
	      _react2.default.createElement(
	        'div',
	        { className: 'g__flex__col team__widget__col' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          team.title,
	          ' ',
	          team.extra ? _react2.default.createElement(
	            'h3',
	            { style: { color: team.extraColor, display: "inline-block" } },
	            ' | ',
	            team.extra
	          ) : _react2.default.createElement('h3', null)
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          team.description
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'team__widget__link__list' },
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: team.applyLink, className: 'g__ex__link apply__link' },
	            'Apply \u2192'
	          ),
	          team.title === "Photo" ? _react2.default.createElement(
	            'p',
	            null,
	            'Photo is not taking requests this Spring'
	          ) : _react2.default.createElement(
	            'a',
	            { target: '_blank', href: _links.applyRequest, className: 'g__ex__link apply__link' },
	            'Request services \u2192'
	          )
	        )
	      ),
	      _react2.default.createElement('img', { className: 'team__img', src: team.img })
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__flex__col teams' },
	    props.content.map(function (team) {
	      return _react2.default.createElement(Team, { team: team });
	    })
	  );
	}
	
	function Officers(props) {
	
	  function Officer(props) {
	    var officer = props.officer;
	    return _react2.default.createElement(
	      'div',
	      { className: 'g__flex__col officer__widget' },
	      _react2.default.createElement(
	        'div',
	        { className: 'officer__widget__square' },
	        _react2.default.createElement('img', { src: officer.img, className: 'officer__widget__img' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'officer__widget__phrase' },
	          officer.phrase
	        )
	      ),
	      _react2.default.createElement(
	        'h4',
	        { className: 'officer__widget__name' },
	        officer.name
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'officer__widget__position' },
	        officer.position
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'officers g__flex__row' },
	    props.content.map(function (officer) {
	      return _react2.default.createElement(Officer, { officer: officer });
	    })
	  );
	}
	
	function AboutPage(props) {
	  // const { officers } = props.data.markdownRemark.frontmatter;
	  // const images = props.data.allFile.edges.reduce((obj, edge) => {
	  //   if (!edge.node.childImageSharp) return obj;
	  //   const resolutions = edge.node.childImageSharp.resolutions;
	  //   obj[resolutions.originalName] = resolutions;
	  //   return obj;
	  // }, {});
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'about' },
	    _react2.default.createElement(_PageHeader2.default, {
	      pageIndicator: 'About',
	      title: 'We have 4 teams!',
	      description: 'Our club and DeCals are led by the Officer Board.  Each VP presides over an aspect of our club\u2019s operation in addition to leading a  Design or Photography team.'
	    }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Teams'
	    ),
	    _react2.default.createElement(Teams, { content: teamsContent }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Values'
	    ),
	    _react2.default.createElement(Values, { content: valuesContent }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'officer__TITLE__MEDIA' },
	      'Officers'
	    ),
	    _react2.default.createElement(Officers, { content: _aboutContent.officerContent }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'FAQ'
	    ),
	    _react2.default.createElement(FAQ, { content: faqContent })
	  );
	}
	
	// export const pageQuery = graphql`
	//   query AboutQuery($path: String!) {
	//     markdownRemark(frontmatter: { path: { eq: $path } }) {
	//       html
	//       frontmatter {
	//         hero_heading
	//         hero_subheading
	//         officers {
	//           name
	//           role
	//           secondary_role
	//           image
	//           hover_blurb
	//         }
	//       }
	//     }
	//     allFile {
	//       edges {
	//         node {
	//           childImageSharp {
	//             resolutions(
	//               traceSVG: {
	//                 color: "lightgray"
	//                 optTolerance: 0.4
	//                 turdSize: 100
	//                 turnPolicy: TURNPOLICY_MAJORITY
	//               },
	//               width: 150,
	//               height: 219,
	//               quality: 100,
	//               cropFocus: CENTER
	//             ) {
	//               width
	//               height
	//               src
	//               srcSet
	//               tracedSVG
	//               originalName
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }
	// `;
	
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var officerContent = [{
	    name: "Sahil Sanghvi",
	    position: "President",
	    phrase: "Enjoys looking at well-made maps",
	    img: "/img/about/officers-sp21/sahil.png"
	}, {
	    name: "Renee Utter",
	    position: "President",
	    phrase: "enjoys hellen keller conspiracy theories",
	    img: "/img/about/officers-sp21/renee.png"
	}, {
	    name: "Annie Lin",
	    position: "VP Services, Web Team Lead",
	    phrase: "did u know ice cream has more carbs than pasta? <3",
	    img: "/img/about/officers-sp21/annie.png"
	}, {
	    name: "Jenny Chen",
	    position: "VP Education Outreach, Gold Team Lead",
	    phrase: "clam chowder is seafood boba",
	    img: "/img/about/officers-sp21/jenny.png"
	}, {
	    name: "Lindsey Guan",
	    position: "VP Education Coordinator, Gold Photo Lead",
	    phrase: "let's talk mason jars",
	    img: "/img/about/officers-sp21/lindsey.png"
	}, {
	    name: "Farhan Hossain",
	    position: "VP External, Blue Team Lead",
	    phrase: "i hate trader joe's takis",
	    img: "/img/about/officers-sp21/farhan.png"
	}, {
	    name: "Kelly Ma",
	    position: "VP Internal, Gold Team Lead",
	    phrase: "needs naps and boba for life",
	    img: "/img/about/officers-sp21/kelly.png"
	}, {
	    name: "Vivian Zhang",
	    position: "Marketing Team Lead",
	    phrase: "holding u soft & gently in the astral plane :,)",
	    img: "/img/about/officers-sp21/vivian.png"
	}, {
	    name: "Jihyun Kim",
	    position: "Marketing Team Lead",
	    phrase: "hot cheetos >> cheetos",
	    img: "/img/about/officers-sp21/jihyun.png"
	}, {
	    name: "Albert Tian",
	    position: "VP Tech",
	    phrase: "1 2 mayweather",
	    img: "/img/about/officers-sp21/albert.png"
	}, {
	    name: "Elly Lee",
	    position: "VP Finance",
	    phrase: "jafeel me?",
	    img: "/img/about/officers-sp21/elly.png"
	}, {
	    name: "Elizabeth Tang",
	    position: "Photo Decal Facilitator",
	    phrase: "i like big crocs and i cannot lie",
	    img: "/img/about/officers-sp21/tang.png"
	}, {
	    name: "Emily Shaw",
	    position: "Intro DeCal Facilitator",
	    phrase: "spirit animal is an egg",
	    img: "/img/about/officers-sp21/emily.png"
	}, {
	    name: "Gloria Fung",
	    position: "Intro DeCal Facilitator",
	    phrase: "latte art amateur",
	    img: "/img/about/officers-sp21/gloria.png"
	}, {
	    name: "Ryan Yu",
	    position: "Intro DeCal Facilitator, Gold Team Lead",
	    phrase: "my name ryan yu",
	    img: "/img/about/officers-sp21/ryan.png"
	}, {
	    name: "Sophie Doucet",
	    position: "Intro DeCal Facilitator",
	    phrase: "I have a cat for each of my hands",
	    img: "img/about/officers-sp21/sophie.png"
	}, {
	    name: "Tucker Beachem",
	    position: "Gold Team Lead",
	    phrase: "in my room",
	    img: "/img/about/officers-sp21/tucker.png"
	}, {
	    name: "Jason Cao",
	    position: "VP Internal, Gold Photo Lead",
	    phrase: "The Chesapeake Bay is the best bay,",
	    img: "/img/about/officers-sp21/jason.png"
	}, {
	    name: "Danny Ha",
	    position: "Senior Advisor",
	    phrase: "reminder to drink some water",
	    img: "/img/about/officers-sp21/danny.png"
	}, {
	    name: "Megan Chai",
	    position: "Blue Team Lead",
	    phrase: "i <3 trader joe's takis",
	    img: "/img/about/officers-sp21/megan.png"
	}, {
	    name: "Joshua Yao",
	    position: "Senior Advisor",
	    phrase: "baja'd his last blast",
	    img: "img/about/officers-sp21/josh.png"
	}];
	
	exports.officerContent = officerContent;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-js-9835c2d0e9e34d4bb179.js